class TradingSessionCollection {
    /**
     * @param {TradingSession[]} sessions
     */
    constructor(sessions) {
        this.sessions = sessions;
    }

    /**
     * @return {TradingSession[]}
     */
    getOpen() {
        return this.sessions.filter((session) => !session.endedAt);
    }

    /**
     * @return {TradingSession[]}
     */
    getAll() {
        return this.sessions;
    }
}

module.exports = TradingSessionCollection;
